import React from 'react';
import { useHistory } from 'react-router-dom';
import '../dashboard/css/Article1.css';
import blogImage from '../dashboard/assets/Article.avif';
import blog1 from '../dashboard/assets/article7.webp';

const Article7 = () => {
  const history = useHistory();

  return (
    <div className="rsh-blog-section">
      {/* Hero */}
      <div
        className="rsh-blog-hero"
        style={{ backgroundImage: `url(${blogImage})` }}
      >
        <div className="rsh-blog-overlay">
          <h1 className="rsh-blog-title">Articles</h1>
          <p className="rsh-breadcrumb">
            <span onClick={() => history.push('/')}>Home</span> / Articles
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="rsh-blog-container">
        <h2 className="rsh-section-title">
          Best Study Habits Every Student in Ahmedabad Should Follow
        </h2>

        <div className="rsh-published-badge">
          Published on: 07 January 2026
        </div>

        <img
          src={blog1}
          alt="5 Habits of Highly Successful Students"
          className="rsh-blog-detail-img"
        />

        <div className="rsh-blog-detail-content">
          <p className="intro-text">
            Academic success is not only about intelligence—it is about habits.
            Students in Ahmedabad who consistently perform well follow a
            structured approach to studying. These proven habits help students
            stay focused, reduce stress, and achieve long-term academic goals.
          </p>

          <p>
            Whether preparing for school exams, board examinations, or entrance
            tests, adopting the right study habits early can make a significant
            difference. Below are the <strong>5 habits of highly successful
            students</strong> that every Ahmedabad student should follow.
          </p>

          {/* HABIT 1 */}
          <div className="info-box">
            <h3>1. Having a Study Routine, Not a Study Rush</h3>
            <p>
              Successful students follow a consistent study routine instead of
              last-minute exam preparation. Studying regularly helps build
              strong concepts and reduces exam anxiety.
            </p>
            <ul>
              <li>Daily fixed study hours</li>
              <li>Avoid cramming before exams</li>
              <li>Balanced time for study and rest</li>
            </ul>
          </div>

          {/* HABIT 2 */}
          <div className="info-box">
            <h3>2. Goal Setting and Smart Planning</h3>
            <p>
              Setting clear academic goals keeps students motivated and
              organized. Successful students break their syllabus into smaller,
              achievable targets.
            </p>
            <ul>
              <li>Daily and weekly study goals</li>
              <li>Proper exam-oriented planning</li>
              <li>Regular progress tracking</li>
            </ul>
          </div>

          {/* HABIT 3 */}
          <div className="info-box">
            <h3>3. Active Learning Rather Than Mere Reading</h3>
            <p>
              Simply reading textbooks is not enough. Active learning improves
              understanding and long-term retention of concepts.
            </p>
            <ul>
              <li>Making short notes and summaries</li>
              <li>Solving practice questions</li>
              <li>Teaching concepts aloud or discussing doubts</li>
            </ul>
          </div>

          {/* HABIT 4 */}
          <div className="info-box">
            <h3>4. Smart Time and Distraction Management</h3>
            <p>
              Time management is a key skill among top-performing students.
              Limiting distractions during study hours leads to better focus
              and productivity.
            </p>
            <ul>
              <li>Limited mobile and social media usage</li>
              <li>Short breaks using the Pomodoro technique</li>
              <li>Organized study space</li>
            </ul>
          </div>

          {/* HABIT 5 */}
          <div className="info-box">
            <h3>5. Seeking Help Early & Taking Care of Health</h3>
            <p>
              Highly successful students never hesitate to seek help when
              needed. They also prioritize physical and mental well-being.
            </p>
            <ul>
              <li>Asking teachers or tutors for clarification</li>
              <li>Maintaining a healthy sleep schedule</li>
              <li>Managing stress through relaxation and exercise</li>
            </ul>
          </div>

          {/* TABLE */}
          <h3 className="table-title">
            Habits of Successful Students vs Struggling Students
          </h3>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Successful Students</th>
                  <th>Struggling Students</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Consistent study routine</td>
                  <td>Last-minute preparation</td>
                </tr>
                <tr>
                  <td>Clear academic goals</td>
                  <td>No planning</td>
                </tr>
                <tr>
                  <td>Active learning methods</td>
                  <td>Passive reading</td>
                </tr>
                <tr>
                  <td>Good time management</td>
                  <td>Frequent distractions</td>
                </tr>
                <tr>
                  <td>Healthy lifestyle</td>
                  <td>Poor sleep & stress</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* FINAL */}
          <div className="info-box">
            <h3>Final Thoughts</h3>
            <p>
              By adopting these five habits, students in Ahmedabad can build a
              strong academic foundation and achieve consistent success.
              Discipline, smart planning, and self-care are the true keys to
              becoming a highly successful student.
            </p>
          </div>

          <div className="rsh-back-btn-wrapper">
            <button
              className="rsh-back-btn"
              onClick={() => history.push('/index')}
            >
              Go Back To Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Article7;